import Loader from '@/components/Loader';
import Constants from '@/Constants';
import { ApplicationState } from '@/store';
import React from 'react';
import Modal from 'react-bootstrap/esm/Modal';
import { useSelector } from 'react-redux';
import './style.scss';

interface PropsType {
    show: boolean;
    setShow: CallableFunction;
    modalQuestionIndex: number;
    modalOptionIds: number[];
    onClickImage?: () => void;
}

const AnsweredQuestionModal = ({ show, setShow, modalQuestionIndex, modalOptionIds, onClickImage }: PropsType) => {
    const { question, strings, loading } = useSelector((state: ApplicationState) => ({
        questionnaire: state.questionnaire.questionnnaire,
        question: state.questionnaire.question,
        loading: state.questionnaire.loading,
        responseSummary: state.questionnaire.responseSummary,
        strings: state.locale.data,
        person: state.identity.data.person,
    }));

    const getImagePathThumb = (imagePath: string) => {
        if (imagePath) {
            let start = imagePath.lastIndexOf('.');

            if (start < 0) {
                start = imagePath.length;
            }

            return imagePath.substring(0, start) + '_thumb' + imagePath.substring(start);
        }

        return '';
    };

    return (
        <Modal aria-labelledby="contained-modal-title-vcenter" centered onHide={() => setShow(false)} show={show} size="lg">
            <Modal.Body className="question-modal-body" style={{ textAlign: 'center' }}>
                <header className="question-modal-header">
                    <span> {`${strings.QUESTION} ${modalQuestionIndex}`} </span>
                    <i className="material-icons" onClick={() => setShow(false)}>
                        {Constants.icons.CLOSE}
                    </i>
                </header>
                {loading ? (
                    <Loader />
                ) : (
                    <>
                        <div>
                            <div className="question-modal-body-description" dangerouslySetInnerHTML={{ __html: question.description }}></div>
                            {question.imagePath && <img alt="" onClick={onClickImage} src={getImagePathThumb(question.imagePath)} />}
                        </div>

                        <table>
                            <tbody className="question-modal-table-body">
                                {question.options.map((o, index) => {
                                    return (
                                        <tr
                                            className={
                                                o.isCorrect
                                                    ? 'correct-answer'
                                                    : modalOptionIds.find((optionId) => optionId === o.id)
                                                    ? 'incorrect-answer'
                                                    : ''
                                            }
                                            key={index}
                                        >
                                            <td>{o.description}</td>
                                            <td>
                                                <span className="material-icons">
                                                    {o.isCorrect
                                                        ? Constants.icons.VALID_CHECK
                                                        : modalOptionIds.find((optionId) => optionId === o.id)
                                                        ? Constants.icons.INVALID_CROSS
                                                        : ''}
                                                </span>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </>
                )}
            </Modal.Body>
        </Modal>
    );
};

export default AnsweredQuestionModal;
